<template>
  <section id="s-integrations-info">
    <IntegrationsSection
      v-if="activeSideTab === 'categories'"
      :partnerSettings="partnerSettings"
      :screen="screen"
      :update="updatePartnerSetting"
      :currentCorporation="currentCorporation"
      :changeStateValue="changeStateValue"
    />
  </section>
</template>

<script>
import IntegrationsSection from './integrationsInfo/IntegrationsSection.vue';

export default {
  name: 'IntegrationsInfo',
  components: {
    IntegrationsSection,
  },
  props: {
    screen: String,
    partnerSettings: Object,
    currentCorporation: Object,
    updatePartnerSetting: Function,
    changeStateValue: Function,
  },
  data() {
    return {
      activeSideTab: 'categories',
    };
  },
  computed: {
    tabOptions() {
      const options = [
        {
          label: 'All Categories',
          value: 'categories',
        },
      ];
      return options;
    },
  },
  mounted() {
    if (this.$route?.query) {
      let setting = null;
      Object.keys(this.$route.query).forEach((q) => {
        if (q.toLowerCase() === 'setting') {
          setting = this.$route.query[q];
        }
      });
      if (setting) {
        const activeSideTab = this.tabOptions.find((o) => (
          o.value.toLowerCase() === setting.toLowerCase()
        ));
        if (activeSideTab) {
          this.activeSideTab = activeSideTab.value;
        }
      }
    }
  },
  methods: {
    changeTab(tab) {
      this.activeSideTab = tab;
    },
  },
};
</script>

<style lang="scss">

section#s-integrations-info {
  display: flex;
  flex: 1;
  padding-right: 100px;
  background-color: $WHITE;
  .sac-lsb-option {
    padding-left: 100px;
  }
  .s-setting-container {
    padding: 20px 0 20px 4rem;
    display: grid;
    align-content: flex-start;
    gap: 20px;
    width: 100%;
    position: relative;

    .main-container {
      flex-wrap: wrap;
      align-items: flex-start;
      display: inline-flex;
      flex: 0 0 auto;
      gap: 16px;
      margin-right: -3px;
      position: relative;
    }

    .slack-img {
      height: 40px;
      object-fit: cover;
      width: 40px;
    }
    .st-img {
      height: 50px;
      object-fit: cover;
      width: 50px;
    }
    .mq-img {
      height: 50px;
      object-fit: cover;
      width: 50px;

    }
    .st-logo {
      width: 193px;
      height: 33px;
      object-fit: cover;
    }
    .example-image {
      width: 387px;
      height: 242px;
      object-fit: cover;
    }

    .slack-info {
      text-decoration: underline;
      align-self: stretch;
      color: #000000;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
    }

    .click-to-add {
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0;
    }

    .review-info {
      font-size: 0.875rem;
      flex-grow: 1;
    }

    .integration {
      align-items: flex-start;
      border: 2px solid $N5;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 24px 16px;
      width: 337px;
      min-height: 300px;

      .i-header {
        align-items: center;
        align-self: stretch;
        background-color: transparent;
        display: flex;
        justify-content: space-between;
        height: 20%;
      }
      .i-connected {
        align-items: center;
        background-color: #66d38373;
        border-radius: 4px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 8px;
        padding: 1px 8px;
        &.pending {
          background-color: #FFE4AF;
        }
        .bullet {
          background-color: #25803d;
          border-radius: 4px;
          height: 8px;
          width: 8px;
          &.pending {
            background-color: #C48500;
          }
        }
        .label-info {
          color: #25803d;
          font-weight: 600;
          font-size: 0.875rem;
          &.pending {
            color: #C48500;
          }
        }
      }
    }
    .i-form-button {
      padding: 0 16px;
      height: 48px;
      border-radius: 6px;
      background-color: $NBLUE100;
      font-weight: 600;
      color: $WHITE;
      width: 100%;
    }
    .i-form-integration {
      border-radius: 6px;
      color: $NBLUE100;
      background-color: white;
      font-weight: 600;
      border: 2px solid $NBLUE100;
      padding: 12px 24px;
      height: 48px;
      width: 100%;
    }
    .main-header {
      font-weight: 700;
      font-size: 1.25rem;
      color: $N100;
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      justify-content: space-between;
      .sub-header {
        font-weight: normal;
        padding: 10px 0;
        font-size: 1rem;
      }
      .save-btn {
        font-weight: 700;
        margin-bottom: 10px;
      }
      .cancel-btn {
        font-weight: 700;
        margin-bottom: 10px;
      }
    }
  }
  .ac-input-container,
  .ac-row-container {
    max-width: 500px;
  }
}
</style>
